export const STALE_TIMES = {
  list: 30_000,
  detail: 60_000,
  analytics: 2 * 60_000,
  config: 5 * 60_000,
} as const;
